import { openSubOrderModal } from '../../../State/subOrderModal'

export default () => (dispatch, getState) => {

  const { order, selectedOrderItemIds } = getState().screens.OrderView

  const modalData = {
    projectId: order.project_id,
    orderItemIds: selectedOrderItemIds.map(row => row.id),
    orderTotal: order.total,
    retentionPercentage: order.retention_percentage,
  }

  dispatch(openSubOrderModal(modalData))

}
